import { render, staticRenderFns } from "./documentView.vue?vue&type=template&id=f0690746&scoped=true"
import script from "./documentView.vue?vue&type=script&lang=js"
export * from "./documentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0690746",
  null
  
)

export default component.exports